import { useState } from 'react';

import ImportacaoSaqueFacil from '../../components/ImportacaoSaqueFacil/ImportacaoSaqueFacil';
import NotifierPopup from '../../components/NotifierPopup/NotifierPopup';

export default function SaqueFacilImportacao() {
    const [notify, setNotify] = useState({
        isActive: false,
        isSuccessful: undefined,
        message: undefined
    });

    return (
        <>
            {notify.isActive && <NotifierPopup notify={notify} setNotify={setNotify} />}
            <ImportacaoSaqueFacil
                setNotifier={(isSuccessful, message) => setNotify({
                    isActive: true,
                    isSuccessful,
                    message
                })}
            />
        </>
    );
}
